import PropTypes from "prop-types"

// Actions
import { toggleToggle } from "components/Stacker/actions/ToggleActions"

// Styles
import "./CustomizeProductConfig.scss"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

function CustomizeProductConfig(configurableProductType) {
  const dispatch = useDispatch()
  const { LL } = useI18nContext()
  const { pinky, enagraveableProductConfig } = useSelector((state) => {
    return {
      pinky: state.productConfig,
      enagraveableProductConfig: state.toggle.enagraveableProductConfig,
    }
  })
  const displayPinkyRingPopup = () => {
    if (!enagraveableProductConfig) {
      dispatch(toggleToggle("enagraveableProductConfig"), true)
    }
  }

  return (
    <div className="CustomizeProductConfig">
      <button
        className="c-btn primary d-flex w-100 align-items-center justify-content-center"
        onClick={displayPinkyRingPopup}
      >
        {configurableProductType === "PENDANT_PRODUCTS"
          ? LL.productConfig.engraveThisNecklaceText()
          : LL.productConfig.engraveThisRingText()}
      </button>
    </div>
  )
}

export default CustomizeProductConfig
